import { Box, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { Material } from 'Types';

import MaterialLabelWithThumb from 'designer/MaterialLabelWithThumb';
import NumberInput from 'designer/NumberInput';
import { settingsAtom } from 'state/recoilState';

type Props = {
  material: Material;
};

function MaterialCostInput(props: Props) {
  const { material } = props;

  const [settings, setSettings] = useRecoilState(settingsAtom);

  const onPriceChange = (price: number) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      materialCosts: {
        ...prevSettings.materialCosts,
        [material]: {
          ...prevSettings.materialCosts[material],
          price,
        },
      },
    }));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        mb: 1,
        mr: 12,
        whiteSpace: 'nowrap',
        alignItems: 'center',
        maxWidth: 320,
      }}
    >
      <Box sx={{ pr: 1, minWidth: 180 }}>
        <MaterialLabelWithThumb material={material} />
      </Box>

      <NumberInput
        id={material + '-cost'}
        label=""
        min={0}
        step={1}
        value={settings.materialCosts[material].price}
        onChange={onPriceChange}
      />

      <Box sx={{ pl: 1 }}>
        <Typography variant="body1" color="inherit">
          $/fbm
        </Typography>
      </Box>
    </Box>
  );
}

export default MaterialCostInput;
